import * as amplitude from '@amplitude/analytics-browser';

function enrichScreenPlugin () {
	return {
		execute: async (event) => {
			event.event_properties = {
				...event.event_properties,
				screen_url: location.href,
				screen_path: location.pathname,
				screen_title: document.title,
				page_host: location.hostname,
			};

			return event;
		},
	};
};

function googleTagManagerPlugin (containerId, apiKey) {
	return {
		type: 'destination',
		execute: async (event) => {
			const payload = {
				k: apiKey || 'apikey',
				d: event,
			};

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

			const response = await fetch(`https://www.googletagmanager.com/gtm.js?id=${containerId}&l=dataLayer`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Accept: '*/*',
				},
				body: JSON.stringify(payload),
			});

			return {
				code: response.status,
				event,
				message: response.statusText,
			};
		},
	};
}

export function createAmplitudeMonitor () {
	amplitude.init(import.meta.env.VITE_AMPLITUDE_API_KEY, {
		defaultTracking: {
			attribution: false,
			pageViews: false,
			sessions: false,
			formInteractions: false,
			fileDownloads: false,
		},
	});

	amplitude.add(enrichScreenPlugin());
	// amplitude.add(googleTagManagerPlugin('GTM-TD2Z68S2'));
}
